(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	$('[data-hover-active]').each(function () {
		var trigger = $(this);
		var target = $(trigger.attr('data-hover-active'));

		trigger.on('mouseenter', function () {
			target.addClass('active');
		}).on('mouseleave', function () {
			target.removeClass('active');
		});
	});
})();
